import React, { useEffect } from 'react'
import { marketCapNumber } from 'utils'
import { PresentationalStateActions, TransactionState } from '../../transactional-context/interface'
import {
  CustomIndexText,
  Divider,
  IndexWrapper,
  InputContainer,
  InputPriceWrapper,
  InputWrapper,
  StrippedInput,
} from '../styled'

import { DEFAULT_INDEX_DECIMALS } from 'app-constants'
import { useDebounce } from 'hooks'
import { Index as SubgraphIndex } from 'hooks/type-of-use-indices'
import { getProductByAddress } from 'indices-list'
import { currencyFormat } from '../../../../../utils/formatting-utils'
import { useTransactionalContext } from '../../transactional-context'
import { enforcer } from '../services'

interface InputProps {
  indexInfo: SubgraphIndex
}
export const SellInputField: React.FC<InputProps> = () => {
  const [inputDollarValue, setInputDollarValue] = React.useState<string>('0')
  const {
    dispatch,
    isBuying,
    redemptionAsset,
    inputIndexAmount,
    loadingValues,
    transactionState,
    productAddress,
  } = useTransactionalContext()
  const [value, setValue] = React.useState<string>(inputIndexAmount)

  const [loading, setLoading] = React.useState<boolean>(loadingValues)
  const debouncedValue = useDebounce<string>(value, 300)

  /**
   * IT: sets the input dollar value
   * WHEN: The input dollar value changes
   * WHY: Because the value is required in other parts of the widget
   */
  useEffect(() => {
    dispatch({
      type: PresentationalStateActions.SET_INPUT_DOLLAR_VALUE,
      payload: inputDollarValue,
    })
  }, [inputDollarValue])

  const handleInput = (target: HTMLInputElement) => enforcer(target, setValue)

  const reset = () => {
    setValue('')
    setInputDollarValue('')
  }

  useEffect(() => {
    reset()
  }, [isBuying, redemptionAsset])

  useEffect(() => {
    if (transactionState === 'idle') {
      reset()
    }
  }, [transactionState])
  useEffect(() => {
    setLoading(true)
    dispatch({
      type: PresentationalStateActions.CHANGE_SELL_INPUT_AMOUNT,
      payload: debouncedValue,
    })
  }, [debouncedValue])

  useEffect(() => {
    setValue(inputIndexAmount)
  }, [inputIndexAmount])
  return (
    <InputContainer open={false}>
      <InputWrapper>
        <StrippedInput
          type="text"
          value={value}
          onChange={({ target }) => handleInput(target)}
          autoComplete="off"
          autoCorrect="off"
          inputMode="decimal"
          pattern={`^[0-9]*[.,]?[0-9]{0,${DEFAULT_INDEX_DECIMALS}}$`}
          placeholder="0.00"
          minLength={1}
          maxLength={100}
          spellCheck="false"
          disabled={transactionState === TransactionState.SUBMITTING}
        />
        <InputPriceWrapper>
          {debouncedValue && Number(debouncedValue) > 0 && !loading
            ? `~${
                inputDollarValue.length > 11
                  ? `$${marketCapNumber(inputDollarValue)}`
                  : currencyFormat(inputDollarValue)
              }`
            : loading
              ? `~$0.00`
              : `~$0.00`}
        </InputPriceWrapper>
      </InputWrapper>
      <Divider />
      <IndexWrapper>
        {/* <CustomIcon fileName={resourcePaths.icon} additionalState={'index-assets'} /> */}
        <CustomIndexText type={'p'}>
          {getProductByAddress(productAddress).symbol.toUpperCase()}
        </CustomIndexText>
      </IndexWrapper>
    </InputContainer>
  )
}
